// export function repairSpace(image_name: string): string {
//   return image_name.split(" ").join("%20");
// }
export function repairSpace(image_name: string): string {
  return image_name.replace(" ", "%20").replace("(", "%28").replace(")", "%29");
  // .replace("!", "%21")
  // .replace(`"`, "%22")
  // .replace("#", "%23")
  // .replace("$", "%24")
  // .replace("&", "%26")
  // .replace("'", "%27")
  // .replace("*", "%2A")
  // .replace("+", "%2B")
  // .replace("-", "%2D")
  // .replace(".", "%2E")
  // .replace("/", "%2F");
}
